export default __webpack_public_path__ + "static/media/mission.bdfff4bd.jpg";